import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "searchFilters",
  class: "o-searchFilters"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  ref: "groups",
  class: "o-buttons o-searchFilters__groups"
}
const _hoisted_4 = ["aria-label", "onClick"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = {
  key: 0,
  class: "o-searchFilters__filter"
}
const _hoisted_7 = ["textContent"]
const _hoisted_8 = {
  key: 0,
  class: "o-tags o-searchFilters__tags"
}
const _hoisted_9 = { class: "o-searchFilters__energyLabels" }
const _hoisted_10 = {
  key: 0,
  class: "o-searchFiltersButtons"
}
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_search_tags = _resolveComponent("m-search-tags")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_m_tag = _resolveComponent("m-tag")!
  const _component_m_range_slider = _resolveComponent("m-range-slider")!
  const _component_m_input = _resolveComponent("m-input")!
  const _component_a_energy_label = _resolveComponent("a-energy-label")!
  const _component_portal = _resolveComponent("portal")!

  return ($data.isDesktop || $options.showInModal)
    ? (_openBlock(), _createBlock(_component_portal, {
        key: 0,
        to: $options.destination
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!$data.isDesktop)
              ? (_openBlock(), _createElementBlock("h3", {
                  key: 0,
                  class: "a-heading3 o-searchFilters__title",
                  textContent: _toDisplayString($props.texts.title)
                }, null, 8 /* PROPS */, _hoisted_2))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_m_search_tags),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.groups, (group, groupIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: groupIndex,
                  ref_for: true,
                  ref: `group-${groupIndex}`,
                  class: _normalizeClass(["o-searchFilters__group", { isOpen: $data.currentGroup === groupIndex }])
                }, [
                  _createElementVNode("button", {
                    class: "m-button m-button--large m-button--shadowed o-searchFilters__groupButton",
                    "aria-label": group.ariaLabel,
                    onClick: _withModifiers(($event: any) => ($options.toggleGroup(groupIndex, $event)), ["stop"])
                  }, [
                    _createElementVNode("span", {
                      class: "a-label m-button__text o-searchFilters__groupName",
                      textContent: _toDisplayString(group.name)
                    }, null, 8 /* PROPS */, _hoisted_5),
                    _createVNode(_component_a_icon, {
                      class: "m-button__icon o-searchFilters__groupIcon",
                      name: "arrow_drop_down"
                    })
                  ], 8 /* PROPS */, _hoisted_4),
                  _createElementVNode("div", {
                    class: _normalizeClass(["o-searchFilters__groupContent", {
                            isOpen: $data.currentGroup === groupIndex,
                            openLeft: $data.currentDirection === 'left',
                            openCenter: $data.currentDirection === 'center',
                        }]),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.filters, (item, itemIndex) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: itemIndex }, [
                        (item.key !== 'Zipcode')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("p", {
                                class: "a-lead o-searchFilters__filterTitle",
                                textContent: _toDisplayString(item.name)
                              }, null, 8 /* PROPS */, _hoisted_7),
                              (item.type === 'tags')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, optionIndex) => {
                                      return (_openBlock(), _createBlock(_component_m_tag, {
                                        key: optionIndex,
                                        checked: 
                                                _ctx.filters.some(
                                                    (i) =>
                                                        i.key === item.key &&
                                                        i.value ===
                                                            option.value,
                                                )
                                            ,
                                        onInput: ($event: any) => (
                                                $options.switchFilter({
                                                    key: item.key,
                                                    label: option.name,
                                                    shortName: item.shortName,
                                                    value: option.value,
                                                })
                                            )
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(option.name), 1 /* TEXT */)
                                        ], undefined, true),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["checked", "onInput"]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]))
                                : (item.type === 'range')
                                  ? (_openBlock(), _createBlock(_component_m_range_slider, {
                                      key: 1,
                                      class: "o-searchFilters__rangeSlider",
                                      append: item.append,
                                      "aria-label": item.name,
                                      "complex-interval": item.complexInterval,
                                      "infinity-indicator": 
                                            item.infinityIndicator
                                        ,
                                      interval: item.interval,
                                      max: item.max,
                                      min: item.min,
                                      prepend: item.prepend,
                                      value: 
                                            _ctx.filters.some(
                                                (i) => i.key === item.key,
                                            )
                                                ? _ctx.filters.find(
                                                      (i) => i.key === item.key,
                                                  ).value
                                                : [item.min, item.max]
                                        ,
                                      "onUpdate:modelValue": ($event: any) => (
                                            $options.updateRange(item, $event)
                                        )
                                    }, null, 8 /* PROPS */, ["append", "aria-label", "complex-interval", "infinity-indicator", "interval", "max", "min", "prepend", "value", "onUpdate:modelValue"]))
                                  : (item.type === 'input')
                                    ? (_openBlock(), _createBlock(_component_m_input, {
                                        key: 2,
                                        class: "o-searchFilters__input",
                                        value: 
                                            _ctx.filters.some(
                                                (i) => i.key === item.key,
                                            )
                                                ? _ctx.filters.find(
                                                      (i) => i.key === item.key,
                                                  ).value
                                                : ''
                                        ,
                                        placeholder: "Postnummer, fx 2100, 8000-8660",
                                        name: "zipcode-filter",
                                        type: "zip",
                                        error: $data.errorMessage,
                                        onInput: ($event: any) => ($options.updateInput(item, $event))
                                      }, null, 8 /* PROPS */, ["value", "error", "onInput"]))
                                    : (item.type === 'valueMapRange')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createElementVNode("div", _hoisted_9, [
                                            _createVNode(_component_a_energy_label, { name: "A" }),
                                            _createVNode(_component_a_energy_label, { name: "B" }),
                                            _createVNode(_component_a_energy_label, { name: "C" }),
                                            _createVNode(_component_a_energy_label, { name: "D" }),
                                            _createVNode(_component_a_energy_label, { name: "E" }),
                                            _createVNode(_component_a_energy_label, { name: "F" }),
                                            _createVNode(_component_a_energy_label, { name: "G" })
                                          ]),
                                          _createVNode(_component_m_range_slider, {
                                            class: "o-searchFilters__rangeSlider",
                                            interval: item.interval,
                                            max: item.max,
                                            min: item.min,
                                            "aria-label": item.name,
                                            type: "valueMapRange",
                                            "value-map": item.valueMap,
                                            value: 
                                            _ctx.filters.some(
                                                (i) => i.key === item.key,
                                            )
                                                ? _ctx.filters.find(
                                                      (i) => i.key === item.key,
                                                  ).value
                                                : [item.min, item.max]
                                        ,
                                            "onUpdate:modelValue": ($event: any) => (
                                            $options.updateValueMapRange(item, $event)
                                        )
                                          }, null, 8 /* PROPS */, ["interval", "max", "min", "aria-label", "value-map", "value", "onUpdate:modelValue"])
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */)
          ], 512 /* NEED_PATCH */),
          (!$data.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: _normalizeClass(["m-button m-button--outlined o-searchFiltersButtons__resetButton", { isDisabled: !$options.hasFilters }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetFilters()))
                }, [
                  _createElementVNode("span", {
                    class: "m-button__text",
                    textContent: _toDisplayString($props.texts.reset)
                  }, null, 8 /* PROPS */, _hoisted_11)
                ], 2 /* CLASS */),
                _createElementVNode("button", {
                  class: "m-button o-searchFiltersButtons__approveButton",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal()))
                }, [
                  _createElementVNode("span", {
                    class: "m-button__text",
                    textContent: _toDisplayString($props.texts.approve)
                  }, null, 8 /* PROPS */, _hoisted_12)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], undefined, true),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]))
    : _createCommentVNode("v-if", true)
}